<div *ngIf="isLoading$ | async" class="loader-mask">
  <sumday-loader [center]="true" loadingMessage="loading"></sumday-loader>
</div>
